/**
 * Das Band über der Kopfzeile, das sagt, dass dies das Testsystem ist.
 *
 * Erkannt am Namen, unter dem die Seite läuft: Das Testsystem heißt
 * `<name>-test.…` (Repo `infra-caddy`, TESTSYSTEM.md). Keine Variable, kein
 * Aufruf — der Name ist die eine Sache, die Produktion und Test sicher
 * unterscheidet, und er ist da, bevor irgendetwas geladen ist. Beim
 * Entwickeln (`localhost`) erscheint nichts.
 *
 * Amber, nicht Rot: Es ist kein Fehler, dass jemand hier ist.
 */
const IST_TESTSYSTEM =
  typeof window !== 'undefined' && /-test$/.test(window.location.hostname.split('.')[0] ?? '');

export function Testband({ className = '' }: { className?: string }) {
  if (!IST_TESTSYSTEM) return null;
  return (
    <div
      role="status"
      className={`border-b border-amber-300 bg-amber-100 px-4 py-1 text-center text-sm font-medium text-amber-900 ${className}`}
    >
      Testsystem: Alles hier ist zum Ausprobieren und wird gelöscht.
    </div>
  );
}
